<template>
  <div>远程杀虫灯监测</div>
</template>

<script>
export default {};
</script>

<style>
</style>